import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Container/Container.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var CONTAINER_CLASSNAME_MAP = {
  size: {
    sm: "pd:max-w-3xl",
    md: ""
  }
};
var Container = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      size = "md",
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "size", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:container", CONTAINER_CLASSNAME_MAP.size[size], className)
  }, rest), {
    children
  }));
});
var StoryContainer = args => /* @__PURE__ */jsx(Container, __spreadValues({}, args));
var Container_default = Container;
export { CONTAINER_CLASSNAME_MAP, StoryContainer, Container_default };